// import get from 'lodash/get';
import { handleError } from 'helper/rest';
import { client } from 'helper/axios';

export const getTopupAll = async ({ token, params }: any) => {
  try {
    return await client
      .get(`topup`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params,
      })
      .then(response => {
        return response;
      })
      .catch(error => {
        const { response } = error;
        handleError(response);
        return response;
      });
  } catch (error) {
    console.error('error', error);
    return error;
  }
};

export const getTopupTotalCount = async ({ token, params }: any) => {
  try {
    return await client
      .get(`topup_total`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params,
      })
      .then(response => {
        return response;
      })
      .catch(error => {
        const { response } = error;
        handleError(response);
        return response;
      });
  } catch (error) {
    console.error('error', error);
    return error;
  }
};

export const getTopupById = async ({ token, params }: any) => {
  try {
    return await client
      .get(`topup/${params?.id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then(response => {
        return response;
      })
      .catch(error => {
        const { response } = error;
        handleError(response);
        return response;
      });
  } catch (error) {
    console.error('error', error);
    return error;
  }
};

export const postCreateTopup = async ({ token, params }: any) => {
  // console.log(params)
  //  console.log(params.topup_logo.file);
  let formData = new FormData();
  //  formData.append('topup_logo', params.topup_logo.fileList[0].originFileObj);
  if (params?.topup_image) {
    formData.append('topup', params.topup_image.file.originFileObj);
  }
  formData.append('topup_promotion_id', params.topup_promotion_id ? params.topup_promotion_id : 0);
  formData.append('topup_bank_id', params.topup_bank_id);
  formData.append('topup_money', params.topup_money);
  formData.append('topup_point', params.topup_point);
  formData.append('topup_point_all', params.topup_point_all);
  formData.append('topup_rate_point', params.topup_rate_point);
  formData.append('topup_rate_money', params.topup_rate_money);
  formData.append('topup_rate_bonus', params.topup_rate_bonus);
  formData.append('topup_rate_free_point', params.topup_rate_free_point);
  formData.append('topup_type', params.topup_type);
  try {
    return await client
      .post(`topup`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'multipart/form-data',
        },
      })
      .then(response => {
        return response;
      })
      .catch(error => {
        const { response } = error;
        handleError(response);
        return response;
      });
  } catch (error) {
    console.error('error', error);
    return error;
  }
};

export const putUpdateStatusTopup = async ({ token, params, id }: any) => {
  try {
    return await client
      .put(`topup/${id}/status`, params, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then(response => {
        return response;
      })
      .catch(error => {
        const { response } = error;
        handleError(response);
        return response;
      });
  } catch (error) {
    console.error('error', error);
    return error;
  }
};

export const deleteTopup = async ({ token, id }: any) => {
  try {
    return await client
      .delete(`topup/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then(response => {
        return response;
      })
      .catch(error => {
        const { response } = error;
        handleError(response);
        return response;
      });
  } catch (error) {
    console.error('error', error);
    return error;
  }
};
